import { routerStyxie } from '@/router/styxieBridge'

// Client-side routed (phase 1 of the GeoBooster migration). The app URLs
// come from GET /gb/ajax/page_meta in the route `prepare`.
Styxie.Initializers.MobileWelcome = routerStyxie({ actions: ['about']})
